'use client';

import {
  InsuranceType,
  useInsuranceSelector
} from '@coolblue-development/next-insurance/insurance-selector';
import { useAddToCartSteps } from '@features/add-to-cart-page/components/AddToCartSteps/AddToCartStepsProvider';
import SectionTitle from '@features/add-to-cart-page/components/SectionTitle/SectionTitle';
import { useTranslation } from '@i18n/useTranslation';

type Props = {
  stepNumber: number;
};

export function InsuranceSectionTitle({ stepNumber }: Props) {
  const { t } = useTranslation('webshop.insurance');
  const { hasMultiStep } = useAddToCartSteps();
  const { selectedGroup } = useInsuranceSelector();

  const isExtendedWarranty = selectedGroup.insuranceType === InsuranceType.EXTENDED_WARRANTY;

  const title = isExtendedWarranty
    ? t('insuranceSectionTitle.extendedWarranty')
    : t('insuranceSectionTitle.default');

  const index = !hasMultiStep ? stepNumber : undefined;

  return <SectionTitle index={index} title={title} />;
}
